<template>
    <div>
        <v-card class="elevation-1">
            <v-card-text>
                <v-layout align-center justify-center v-if="view=='student'" >
                    <v-flex xs12 sm12 md12 lg12 xl12>
                        <v-layout>
                            <v-flex style="font-size: 40px;color:#3b5998;border-bottom: 1px solid #3b5998;">
                                <label class="hideInMobile">{{exercise.name}}</label>
                                <div style="float: right;position: relative;width: 200px;color: red;font-size: 20px;font-weight: bold;line-height: 60px">
                                    {{remainTime}}
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout class="hideInMobile">
                            <v-flex xs12 sm6 md6 lg6 xl6>
                                <label class="label">{{$t('lang.exercise.dueDate')}}:</label>
                                {{exercise.dueDate | formatDate}}
                            </v-flex>
                            <v-flex xs12 sm6 md6 lg6 xl6>
                                <label class="label">{{$t('lang.exercise.questionTime')}}:</label>
                                {{exercise.questionTime}} phút
                            </v-flex>
                            <!--v-flex xs12 sm6 md6 lg6 xl6>
                                <label class="label">{{$t('lang.exercise.effectiveDate')}}:</label>
                                {{exercise.effectiveDate | formatDate}}
                            </v-flex-->
                        </v-layout>
                        <v-layout class="hideInMobile">
                            <v-flex xs12 sm12 md12 lg12 xl2>
                                <label class="label">Hướng dẫn làm bài: </label>
                                {{exercise.guideline}}
                            </v-flex>
                        </v-layout>
                        <!--v-layout>
                            <v-flex xs12 sm6 md6 lg6 xl6>
                                <label class="label">{{$t('lang.exercise.subject')}}:</label>
                                {{exercise.subject}}
                            </v-flex>
                            <v-flex xs12 sm6 md6 lg6 xl6>
                                <label class="label">{{$t('lang.exercise.markScale')}}:</label>
                                {{exercise.markScale}}
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm6 md6 lg6 xl6>
                                <label class="label">{{$t('lang.exercise.numberOfQuiz')}}:</label>
                                {{exercise.numberOfQuiz}}
                            </v-flex>
                        </v-layout-->
                    </v-flex>
                </v-layout>
                <v-layout v-else>
                    <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 10px; margin:10px;border: 1px solid #9E9E9E;">
                        <v-layout>
                            <v-flex xs4 sm4 md4 lg4 xl4>
                                <label class="label">{{$t('lang.exercise.student')}}:</label>
                                {{answer.userName}}
                            </v-flex>
                            <v-flex xs4 sm4 md4 lg4 xl4>
                                <label class="label">{{$t('lang.exercise.endTime')}}:</label>
                                {{answer.endTime | formatDateTime}}
                            </v-flex>
                            <v-flex xs4 sm4 md4 lg4 xl4>
                                <label class="label">Thời gian làm bài:</label>
                                {{calculateWorkTime()}}
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout style="background-color: white" wrap>
                    <v-flex
                            xs12
                            sm12
                            md8
                            lg8
                            xl8
                            style="border:1px solid gray; border-radius:5px;padding:10px;max-height: 800px;overflow: auto"
                            class="view_exercise"
                    >
                        <table class="lstTable">
                            <tr class="yoprimary">
                                <td colspan="2">Danh sách tệp câu hỏi</td>
                            </tr>
                            <tr v-for="att in attachs" :key="'att'+att.attachId">
                                <td style="text-align: left" width="60%"><a
                                        @click="viewAtt(att)">{{att.fileName}}</a></td>
                                <td style="text-align: center" width="40%"><a
                                        @click="downloadAtt(att)">
                                    <v-icon>cloud_download</v-icon>
                                </a></td>
                            </tr>
                        </table>
                        <table class="lstTable"
                               v-if="exercise.answerAttachId != null && ((exercise.permission==1 && (answer.status == 2 || answer.status == 3 || answer.status==4))|| view=='teacher')">
                            <tr class="yoprimary">
                                <td colspan="2">Lời giải chi tiết</td>
                            </tr>
                            <tr>
                                <td style="text-align: left" width="60%"><a
                                        @click="viewAnswerAtt(exercise.answerAttachId,exercise.answerAttachType)">Lời
                                    giải chi tiết</a>
                                </td>
                                <td style="text-align: center" width="40%"><a
                                        @click="downloadAnswerAtt()">
                                    <v-icon>cloud_download</v-icon>
                                </a></td>
                            </tr>
                        </table>
                        <div class="code" v-if="exercise.content != null && exercise.content != '' ">
                            {{exercise.content}}
                        </div>
                        <file-view
                                :editable="false"
                                accept=".pdf, image/*"
                                :key="attachId"
                                :attachId="attachId"
                                :attachType="attachType"
                        />
                    </v-flex>
                    <v-flex
                            xs12
                            sm12
                            md4
                            lg4
                            xl4
                            style="border:1px solid gray; border-radius:5px; padding: 10px"
                            class="do_exercise"
                    >
                        <div>
                            <table class="lstTable" style="margin-top: 10px">
                                <tr class="yoprimary">
                                    <td :colspan="numberOfColspan">Danh sách tệp bài làm</td>
                                </tr>
                                <tr v-for="att in answerAttachs" :key="'ansAtt'+att.attachId">
                                    <td style="text-align: left" width="60%"><a
                                            @click="viewAtt(att)">{{att.fileName}}</a></td>
                                    <td style="text-align: center" width="20%"><a
                                            @click="downloadAtt(att)">
                                        <v-icon>cloud_download</v-icon>
                                    </a></td>
                                    <td style="text-align: center" v-if="view=='student' && (answer.status == 1 || answer.status == 0)" width="20%"><a
                                            @click="deletedAtt(att)">
                                        <v-icon>delete</v-icon>
                                    </a></td>
                                </tr>
                                <tr v-if="editable">
                                    <td :colspan="numberOfColspan">
                                        <file-view
                                                :editable="editable"
                                                :show-file="false"
                                                accept=".pdf, image/*"
                                                :attachId="answer.attachId"
                                                :attachType="answer.attachType"
                                                @change="uploadNewFile"
                                        />
                                    </td>
                                </tr>
                            </table>

                        </div>
                        <div v-if="answer.status == 2 || answer.status == 3 || answer.status == 4">
                            <v-form @keyup.enter.native="onSave">
                                <v-text-field append-icon="format_list_numbered" v-validate="'required|decimal:2'"
                                              :label="$t('lang.exercise.mark')"
                                              v-model="answer.mark"
                                              name="mark"
                                              :readonly="editCommentStatus"
                                              :data-vv-as="$t('lang.exercise.mark')"
                                              :error-messages="errors.first('mark')"/>
                                <label class="label">{{$t('lang.exercise.comment')}}</label>
                                <br/>
                                <v-text-field append-icon="thumb_up" v-validate="'required'"
                                              :label="$t('lang.exercise.teacherComment')"
                                              :data-vv-as="$t('lang.exercise.teacherComment')"
                                              v-model="answer.teacherComment"
                                              name="teacherComment"
                                              :readonly="editCommentStatus"
                                              list="commentSuggest"
                                              :error-messages="errors.first('teacherComment')"/>
                                <datalist id="commentSuggest">
                                    <option value="Tốt"/>
                                    <option value="Rất tốt"/>
                                </datalist>
                                <!--v-text-field append-icon="trending_down" v-validate="'required'"
                                              :label="$t('lang.exercise.teacherCommentImprove')"
                                              v-model="answer.teacherCommentImprove"
                                              :data-vv-as="$t('lang.exercise.teacherCommentImprove')"
                                              name="teacherCommentImprove"
                                              :readonly="editCommentStatus"
                                              list="attitudeCommentSuggest"
                                              :error-messages="errors.first('teacherCommentImprove')"/>
                                <datalist id="attitudeCommentSuggest">
                                    <option value="Rất nghiêm túc"/>
                                    <option value="Nghiêm túc"/>
                                    <option value="Thiếu tích cực"/>
                                </datalist-->
                            </v-form>
                        </div>
                        <div>
                            <v-spacer></v-spacer>
                            <v-btn color="cancel" @click="cancel">
                                {{ $t('lang.common.back') }}
                            </v-btn>
                            <v-btn color="primary" dark @click="onSave"
                                   v-if="user.role == 2 && (answer.status == 1 || answer.status == 0)">
                                {{$t('lang.common.save')}}
                            </v-btn>
                            <v-btn class="yoprimary" dark @click="onSend"
                                   v-if="user.role == 2 && (answer.status == 1 || answer.status == 0) && !isExpire(exercise.dueDate)">
                                {{$t('lang.class.sendExercise')}}
                            </v-btn>
                            <v-btn class="primary" dark @click="onMark"
                                   v-if="user.role == 4 && (answer.status == 2 || answer.status == 3)">
                                {{$t('lang.common.save')}}
                            </v-btn>
                            <v-btn class="yoprimary" dark @click="onSendMark"
                                   v-if="user.role == 4 && (answer.status == 2 || answer.status == 3)">
                                {{$t('lang.exercise.returnExercise')}}
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import {message} from "../../services";
    import IDatepicker from "../../components/form/DatePicker";
    import axios from "axios";
    import IUpload from "../../components/form/Upload";
    import pdf from "vue-pdf";
    import FileView from "./fileView";

    export default {
        name: "do-essay",
        components: {
            pdf,
            IUpload,
            IDatepicker,
            FileView
        },

        props: {
            exerciseType: {
                type: Number,
                default: 5
            },
            view: {
                type: String,
                default: () => {
                    return "student";
                }
            },
            classId: {
                type: String | Number,
                default: () => {
                    return null;
                }
            },

            question: {
                type: Object,
                default: () => {
                    return null;
                }
            },

            studentId: {
                type: String | Number,
                default: () => {
                    return null;
                }
            }
        },

        data() {
            return {
                uploadAnswer: null,
                user: {},
                interval: null,
                remainTime: "",
                clazz: {},
                hardLevelItems: [1, 2, 3, 4, 5],
                accept: ".pdf, image/*",
                numberOfQuiz: 0,
                fileName: "",
                numPages: 0,
                currentPage: 1,
                attachPath: "",
                fileType: "",
                answer: {},
                exercise: {},
                answerAttachs: [],
                attachs: [],
                attachId: null,
                attachType: null,
            };
        },

        watch: {},

        created() {
            this.user = this.$store.state.auth.user;
            if (this.question != null) {
                ////console.log(this.question);
                this.exercise.questionId = this.question.questionId;
                this.exercise.name = this.question.name;
                this.exercise.subject = this.question.subject;
                this.exercise.content = this.question.content;
                this.exercise.questionTime = this.question.questionTime;
                this.exercise.numberOfQuiz = this.question.numberOfQuiz;
                this.exercise.dueDate = this.question.dueDate;
                this.exercise.effectiveDate = this.question.effectiveDate;
                this.exercise.markScale = this.question.markScale;
                this.exercise.question = this.question.question;
                this.exercise.attachId = this.question.attachId;
                this.exercise.attachType = this.question.attachType;
                this.exercise.answerAttachId = this.question.answerAttachId;
                this.exercise.answerAttachType = this.question.answerAttachType;
                this.exercise.permission = this.question.permission;
                this.exercise.guideline = this.question.guideline;

                if (this.question.attachs == undefined || this.question.attachs == null) {
                    this.attachs = [];
                } else {
                    this.attachs = JSON.parse(this.question.attachs);
                    if (this.attachs.length > 0) {
                        this.attachId = this.attachs[0].attachId;
                        this.attachType = this.attachs[0].type;
                    }
                }

                if (this.question.answer == undefined || this.question.answer == null) {
                    this.answer = {};
                } else {
                    this.answer = this.question.answer;
                    if (this.answer.attachs == undefined || this.answer.attachs == null) {
                        this.answerAttachs = [];
                    } else {
                        this.answerAttachs = JSON.parse(this.answer.attachs);
                        /*
                                                if(this.answerAttachs.length>0) {
                                                    this.attachId = this.answerAttachs[0].attachId;
                                                    this.attachType = this.answerAttachs[0].type;
                                                }
                        */
                    }
                    if (this.user.role == 2 && (this.answer.status == 1 || this.answer.status == 0)) {
                        this.interval = setInterval(this.calculateTime, 1000);
                    }
                }
                if (this.studentId != null) {
                    let asw = {
                        'exerciseId': this.question.questionId,
                        'exerciseType': this.exerciseType,
                        'userId': this.studentId
                    }
                    axios.post(process.env.VUE_APP_API_URL + "/exercise/getStudentAnswer", asw).then(
                        data => {
                            this.answer = data;
                            if (this.answer.attachs == undefined || this.answer.attachs == null) {
                                this.answerAttachs = [];
                            } else {
                                this.answerAttachs = JSON.parse(this.answer.attachs);
                                if (this.answerAttachs.length > 0) {
                                    this.attachId = this.answerAttachs[0].attachId;
                                    this.attachType = this.answerAttachs[0].type;
                                }
                            }

                            ////console.log(this.answer);
                        },
                        error => {

                        }
                    )
                }
            } else {
                this.exercise.questionId = null;
                this.exercise.name = "";
                this.exercise.subject = "";
                this.exercise.questionTime = 90;
                this.numberOfQuiz = 0;
                this.exercise.dueDate = null;
                this.exercise.effectiveDate = null;
                this.exercise.markScale = 10;
                this.exercise.question = null;
                this.exercise.attachId = null;
                this.exercise.attachType = null;
                this.exercise.answerAttachId = null;
                this.exercise.answerAttachType = null;
            }
        },

        computed: {
            editable: function () {
                if (this.answer == null) {

                }
                if (this.view != "student") {
                    return false;
                } else if (this.answer.status == undefined || this.answer.status == null || this.answer.status == 0 || this.answer.status == 1) {
                    return true;
                } else {
                    return false;
                }
            },

            editCommentStatus: function () {
                if (this.view == "student") {
                    //console.log("view student return false");
                    return true;
                } else if (this.answer.status == 2 || this.answer.status == 3) {
                    //console.log("view teacher return true");
                    return false;
                } else {
                    return true;
                }
            },

            numberOfColspan(){
                if(this.view=='student' && (this.answer.status ==0 || this.answer.status ==1)){
                    return 3;
                } else {
                    return 2;
                }
            }

        },

        methods: {
            calculateWorkTime: function () {
                if (this.answer.status < 2) {
                    return "";
                } else {
                    if (this.answer.startTime == null || this.answer.endTime == null) {
                        return "";
                    } else {
                        let start = new Date(this.answer.startTime);
                        let end = new Date(this.answer.endTime);
                        let duration = parseInt((end.getTime() - start.getTime()) / 1000);
                        let second = duration % 60;
                        duration = parseInt(duration / 60);
                        let minutes = duration % 60; //minutes instead of asMinutes
                        duration = parseInt(duration / 60);
                        let hours = duration % 24; //hours instead of asHours
                        let str = "";
                        if (hours > 0) {
                            str = hours + "h:";
                        }
                        str += minutes + "m:" + second + "s";
                        return str;
                    }
                }
            },

            calculateTime: function () {
                if (this.answer.status >= 2) {
                    this.remainTime = "Đã kết thúc";
                } else {
                    if (this.question.questionTime == null || this.question.questionTime == "") {
                        this.remainTime = "";
                    } else {
                        let now = new Date();
                        let start = new Date(this.answer.startTime);
                        let questionTime = this.question.questionTime * 60;
                        let duration = questionTime - parseInt((now.getTime() - start.getTime()) / 1000);
                        if (duration <= 0) {
                            if(!this.isExpire(this.exercise.dueDate)) {
                                alert("Bạn đã hết giờ làm bài, nộp bài ngay bây giờ");
                                this.autoSend();
                            }
                            clearInterval(this.interval);
                            this.interval = null;
                        }
                        let second = duration % 60;
                        duration = parseInt(duration / 60);
                        let minutes = duration % 60; //minutes instead of asMinutes
                        duration = parseInt(duration / 60);
                        let hours = duration % 24; //hours instead of asHours
                        this.remainTime = hours + "h:" + minutes + "m:" + second + "s";
                    }
                }
            },

            isExpire(time){
                time = time +"T23:59:59";
                let now = new Date();
                let t = new Date(time);
                ////console.log(time);
                ////console.log(t);
                if (t.getTime() < now.getTime()) {
                    ////console.log("true");
                    return true;
                } else {
                    return false;
                }

            },

            save(status) {
                //console.log(this.answer);
                let answerExercise = {
                    exerciseId: this.exercise.questionId,
                    exerciseType: this.exerciseType,
                    attachId: this.answer.attachId,
                    attachType: this.answer.attachType,
                    attachs: this.answer.attachs
                };
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                        "/exercise/completeExercise?status=" + status + "&classId=" + this.classId,
                        answerExercise
                    )
                    .then(
                        data => {
                            if (data.success) {
                                if (status == 2) {
                                    message.success("Nộp bài thành công");
                                    this.answer.status = 2;
                                } else {
                                    message.success(this.$t("lang.common.save_success"));
                                }
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    );
            },

            onSave: function () {
                if (this.user.role == 2 && (this.answer.status == 1 || this.answer.status == 0)) {
                    this.answer.attachs = JSON.stringify(this.answerAttachs);
                    if (this.answer.attachs == null || this.answer.attachs.length == 0) {
                        message.error("Chưa upload file kết quả");
                    } else {
                        this.save(1);
                    }
                } else if (this.user.role == 1 && (this.answer.status == 2 || this.answer.status == 3)) {
                    this.onMark();
                } else {
                    this.cancel();
                }
            },

            onSend() {
                this.answer.attachs = JSON.stringify(this.answerAttachs);
                if (this.answer.attachs == null || this.answer.attachs.length == 0) {
                    message.error("Chưa upload file kết quả");
                } else {
                    if (!confirm("Bạn có chắc chắn muốn nộp bài không?")) {
                        return;
                    }
                    this.save(2);
                }
            },

            autoSend(){
                this.save(2);
            },

            onMark() {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    if (this.answer.mark > this.exercise.markScale) {
                        message.error("Điểm đã nhập không được lớn hơn thang điểm");
                        return;
                    }
                    let answerExercise = {
                        'exerciseId': this.exercise.questionId,
                        'exerciseType': this.exerciseType,
                        'userId': this.answer.userId,
                        'mark': this.answer.mark,
                        'teacherComment': this.answer.teacherComment,
                        'teacherCommentImprove': this.answer.teacherCommentImprove
                    };
                    axios.post(
                        process.env.VUE_APP_API_URL +
                        "/exercise/saveExerciseMark",
                        answerExercise
                    ).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.save_success"));
                                this.cancel();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    );
                });
            },

            onSendMark() {
                this.$validator.validate().then(valid => {
                        if (!valid) {
                            message.error(this.$t("lang.common.validate_fail"));
                            return;
                        }
                        if (this.answer.mark > this.exercise.markScale) {
                            message.error("Điểm đã nhập không được lớn hơn thang điểm");
                            return;
                        }
                        let answerExercise = {
                            'exerciseId': this.exercise.questionId,
                            'exerciseType': this.exerciseType,
                            'userId': this.answer.userId,
                            'mark': this.answer.mark,
                            'teacherComment': this.answer.teacherComment,
                            'teacherCommentImprove': this.answer.teacherCommentImprove
                        };
                        axios.post(
                            process.env.VUE_APP_API_URL +
                            "/exercise/sendExerciseMark",
                            answerExercise
                        )
                            .then(
                                data => {
                                    if (data.success) {
                                        message.success(this.$t("lang.common.save_success"));
                                        this.cancel();
                                    } else {
                                        message.error(this.$t(data.description));
                                    }
                                },
                                error => {
                                    //console.log(error);
                                }
                            );
                    }
                );
            },

            viewAnswerAtt: function (attachId, attachType) {
                this.attachType = attachType;
                this.attachId = attachId;
            },

            viewAtt: function (att) {
                this.attachType = att.type;
                this.attachId = att.attachId;
            },
            downloadAtt: function (att) {
                window.location = process.env.VUE_APP_API_URL + "/download/attach/" + att.attachId;
            },

            downloadAnswerAtt(){
                window.location = process.env.VUE_APP_API_URL + "/download/attach/" + this.exercise.answerAttachId;
            },

            deletedAtt: function (att) {
                for (let i = 0; i < this.answerAttachs.length; i++) {
                    if (this.answerAttachs[i].attachId == att.attachId) {
                        this.answerAttachs.splice(i, 1);
                        break;
                    }
                }
            },

            uploadNewFile: function (data) {
                this.answer.attachId = data.id;
                this.answer.attachType = data.type;

                let md = {
                    url: process.env.VUE_APP_API_URL + "/download/attach/" + data.id,
                    attachId: data.id,
                    type: data.type,
                    fileName: data.fileName
                }
                this.attachId = data.id;
                this.attachType = data.type;
                if (this.answerAttachs == null) {
                    this.answerAttachs = [md];
                } else {
                    this.answerAttachs.push(md);
                }
            },

            cancel: function () {
                this.$emit("onback");
            }
        }
    };
</script>

